import { Skeleton } from 'antd';
import styled from 'styled-components';
export const RecipeImage = styled(Skeleton.Node).withConfig({
  displayName: "RecipeThumbstyle__RecipeImage",
  componentId: "sc-rg3fmi-0"
})(["", ""], {
  "position": "relative !important",
  "aspectRatio": "1 / 1 !important",
  "height": "auto !important",
  "width": "100% !important",
  "borderRadius": "1rem !important"
});
export const Viewer = styled(Skeleton.Button).withConfig({
  displayName: "RecipeThumbstyle__Viewer",
  componentId: "sc-rg3fmi-1"
})(["", ""], {
  "position": "absolute",
  "bottom": "0.5rem",
  "left": "0.5rem",
  "height": "1.5rem !important"
});
export const Name = styled(Skeleton.Input).withConfig({
  displayName: "RecipeThumbstyle__Name",
  componentId: "sc-rg3fmi-2"
})(["", ""], {
  "marginBottom": "2.5rem !important",
  "marginTop": "0.25rem !important",
  "height": "1.75rem !important"
});